import lb from '@/lib/loopback';

export function countDocumentos() {
  return lb
    .get('/Documentos/count')
    .then(res => res.count);
}

export function findDocumentos(settings = {}) {
  return lb
    .find('/Documentos/', settings)
    .then(data => data);
}

export function deleteDocumento(id) {
  return lb.delete(`/Documentos/${id}`);
}

export function updateDocumento(document) {
  return lb.patch(`/Documentos/${document.id}`, document)
    .then(data => data);
}

export function createDocumento(document) {
  return lb.post('/Documentos/', document)
    .then(data => data);
}

export function bulkUpdateNivelDocumentos(ids, nivel) {
  return lb.post('/Documentos/bulk-update-nivel', { ids, nivel });
}

export function bulkDeleteDocumentos(ids) {
  return lb.post('/Documentos/bulk-delete', { ids });
}

export default {
  countDocumentos, findDocumentos, deleteDocumento, createDocumento, updateDocumento,
  bulkUpdateNivelDocumentos, bulkDeleteDocumentos,
};
